<template>
  <el-timeline-item class="message-timeline-item"
                    :timestamp="message.date"
                    placement="top"
                    :type="messageType"
                    :icon="messageIcon">
    <div :class="['message-item-cont', {'is-read': message.isRead}]"
         @click="messageClick">
      <div class="header">
        <span class="title theme-text">{{message.title}}</span>
      </div>
      <div class="main">
        <div class="content">{{message.message}}</div>
      </div>
      <div class="drawer theme-border layout-animate"
           @click.stop>
        <div class="drawer-btn theme-light-bg">
          <el-tooltip v-if="!message.isRead" content="置为已读" placement="top">
            <el-button type="text" @click="handleRead">
              <i class="el-icon-check"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip v-if="message.isMark" content="取消标记" placement="top">
            <el-button type="text" @click="handleUnMark">
              <i class="el-icon-star-on"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip v-else content="标记" placement="top">
            <el-button type="text" @click="handleMark">
              <i class="el-icon-star-off"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip content="删除" placement="top">
            <el-button type="text" @click="handleDelete">
              <i class="el-icon-delete"></i>
            </el-button>
          </el-tooltip>
        </div>
      </div>
    </div>
  </el-timeline-item>
</template>

<script>
import MessageHandle from '../../../mixins/message/handle'
import messageEvent from '../../../constants/messageEvent'
export default {
  name: 'MessageTimelineItem',
  mixins: [MessageHandle],
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  computed: {
    messageType: function () {
      return this.message.isRead ? 'success' : 'warning'
    },
    messageIcon: function () {
      if (this.message.isMark) {
        return 'el-icon-star-on'
      }
      if (this.message.isRead) {
        return 'el-icon-circle-check'
      }
      return 'el-icon-message-solid'
    }
  },
  methods: {
    handleRead () {
      if (!this.message.isRead) {
        this.$ajax({
          url: '/support/message/biz/notification/setRead',
          method: 'post',
          data: this.$qs.stringify({
            id: this.message.id
          })
        }).then(() => {
          this.$set(this.message, 'isRead', 1)
          this.$bus.$emit(messageEvent.subscribe.READ_MESSAGE, this.message)
        })
      }
    },
    handleMark () {
      if (!this.message.isMark) {
        this.$ajax({
          url: '/support/message/biz/notification/setMark',
          method: 'post',
          data: this.$qs.stringify({
            id: this.message.id
          })
        }).then(() => {
          this.$set(this.message, 'isMark', 1)
          this.$bus.$emit(messageEvent.subscribe.MARK_MESSAGE, this.message)
        })
      }
    },
    handleUnMark () {
      if (this.message.isMark) {
        this.$ajax({
          url: '/support/message/biz/notification/setUnMark',
          method: 'post',
          data: this.$qs.stringify({
            id: this.message.id
          })
        }).then(() => {
          this.$delete(this.message, 'isMark')
          this.$bus.$emit(messageEvent.subscribe.UNMARK_MESSAGE, this.message)
        })
      }
    },
    handleDelete () {
      this.$ajax({
        url: '/support/message/biz/notification/setDelete',
        method: 'post',
        data: this.$qs.stringify({
          id: this.message.id
        })
      }).then(() => {
        this.$emit('delete', this.message)
        this.$bus.$emit(messageEvent.subscribe.DELETE_MESSAGE, this.message)
      })
    },
    messageClick () {
      this.handleRead()
      this.$nextTick(() => {
        this.onMessageClick(this.message)
      })
    }
  }
}
</script>

<style lang="scss">
  @import "../../../styles/common";
  .message-timeline-item {
    padding-bottom: 15px!important;
    &:last-child {
      padding-bottom: 0!important;
    }
    .el-timeline-item__tail {
      border-color: #f0f2f5;
    }
    .el-timeline-item__node {
      left: -2px;
      width: 13px;
      height: 13px;
      .el-timeline-item__icon {
        transform: scale(.8);
      }
    }
    .el-timeline-item__wrapper {
      .el-timeline-item__timestamp {
        &.is-top {
          font-size: 12px;
          padding-top: 3px;
          @extend .console-font;
        }
      }
    }
    .message-item-cont {
      position: relative;
      overflow: hidden;
      cursor: pointer;
      margin: -5px 0 -5px -60px;
      padding: 5px 0 5px 60px;
      background: linear-gradient(to right, #f0f2f5 0%, #f0f2f5 75%, transparent 100%) no-repeat;
      background-size: 0 100%;
      transition: all .5s ease-out;
      &:hover {
        background-size: 100% 100%;
      }
      &:active {
        background-image: linear-gradient(to right, #e6e8eb 0%, #e6e8eb 75%, transparent 100%);
      }
      & > .header {
        & > .title {
          font-size: 12px;
        }
      }
      & > .main {
        margin-top: 5px;
        .content {
          font-size: 12px;
          line-height: 20px;
          word-break: break-all;
          word-wrap: break-word;
          padding-right: 20px;
        }
      }
      & > .drawer {
        position: absolute;
        right: -1px;
        top: 0;
        bottom: 0;
        background-color: #fff;
        border-left: 2px solid;
        transform: translateX(100%);
        & > .drawer-btn {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
          padding-left: 8px;
          padding-right: 16px;
          .el-button {
            & + .el-button {
              margin-left: 8px;
            }
          }
        }
      }
      &:hover {
        & > .drawer {
          transform: translateX(0);
        }
      }
      &.is-read {
        & > .main {
          opacity: .5;
        }
      }
    }
  }
</style>
